export const CATEGORY_ID = {
  WHOLE_BLOOD: 35,
  PRBS: 31,
  FROZEN_PLASMA: 34,
  FRESH_FROZEN_PLASMA: 33,
  UNCATEGORIZED: 16,
  MEDICAL_SUPPLY: 36,
};
